import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ojc-popup" }
const _hoisted_2 = { class: "card border-0" }
const _hoisted_3 = { class: "card-header bg-primary text-white" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "ojc-summary mb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "ojc-overlap-summary"
}
const _hoisted_12 = {
  key: 2,
  class: "spinner-border spinner-border-sm text-primary ms-2",
  role: "status"
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger py-2",
  role: "alert"
}
const _hoisted_14 = { class: "table table-bordered calendar-table mb-2" }
const _hoisted_15 = ["title", "onClick"]
const _hoisted_16 = { class: "d-flex justify-content-between" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = {
  key: 0,
  class: "badge bg-warning text-dark"
}
const _hoisted_19 = {
  key: 1,
  class: "badge bg-warning text-dark ms-1"
}
const _hoisted_20 = {
  key: 0,
  class: "ojc-na"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 2,
  class: "ojc-add-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobModal = _resolveComponent("JobModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ojc-overlay",
    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "ojc-close-popup",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        "aria-label": "Close"
      }, "×"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, "Jobs - " + _toDisplayString(_ctx.officerName), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-secondary",
              disabled: _ctx.loading,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousMonth && _ctx.previousMonth(...args)))
            }, "< Prev", 8, _hoisted_7),
            _createElementVNode("strong", null, _toDisplayString(_ctx.monthLabel), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-secondary",
              disabled: _ctx.loading,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
            }, "Next >", 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.isPastMonth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createTextVNode("Free days left this month: ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.summary.freeDaysLeft), 1),
                  _cache[6] || (_cache[6] = _createTextVNode(" · ", -1))
                ]))
              : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createTextVNode(" Working days: ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.summary.workingDays), 1),
            _cache[9] || (_cache[9] = _createTextVNode(" · Hours: ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.summary.hours), 1),
            (_ctx.summary.overlapDays)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createTextVNode(" · ⚠ Days with overlapping jobs: ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.summary.overlapDays), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          (_ctx.message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdayLabels, (label) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: label,
                    class: "text-center"
                  }, _toDisplayString(label), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarWeeks, (week, wIdx) => {
                return (_openBlock(), _createElementBlock("tr", { key: wIdx }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (cell) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: cell.key,
                      class: _normalizeClass(["calendar-cell", _ctx.cellClass(cell)]),
                      title: _ctx.cellTitle(cell),
                      onClick: ($event: any) => (_ctx.onCellClick(cell))
                    }, [
                      (cell.inCurrentMonth)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(cell.day), 1),
                              _createElementVNode("span", null, [
                                (cell.hasOverlap)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Overlap"))
                                  : _createCommentVNode("", true),
                                (cell.isClash)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Clash"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (cell.nonAvailability)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  (cell.nonAvailability.status === 'Pending')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "⏳ "))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(_toDisplayString(cell.nonAvailability.nonAvailabilityType || "Unavailable"), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.expandedDays[cell.key] ? cell.jobs : cell.jobs.slice(0, _ctx.maxJobsPerCell)), (job) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: job.jobId,
                                class: "ojc-job",
                                title: _ctx.jobTitle(job),
                                onClick: _withModifiers(($event: any) => (_ctx.editJob(job)), ["stop"])
                              }, [
                                (_ctx.overlapsByJobId[job.jobId])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "⚠ "))
                                  : _createCommentVNode("", true),
                                _createTextVNode(_toDisplayString(_ctx.jobLabel(job)), 1)
                              ], 8, _hoisted_22))
                            }), 128)),
                            (cell.jobs.length > _ctx.maxJobsPerCell)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "ojc-more",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleExpanded(cell.key)), ["stop"])
                                }, _toDisplayString(_ctx.expandedDays[cell.key] ? "Show less" : `+${cell.jobs.length - _ctx.maxJobsPerCell} more`), 9, _hoisted_24))
                              : _createCommentVNode("", true),
                            (cell.canAddJob)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, "+ Add job"))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_15))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"ojc-legend\" data-v-449a6627><span data-v-449a6627><i class=\"ojc-swatch cell-free\" data-v-449a6627></i>Free</span><span data-v-449a6627><i class=\"ojc-swatch cell-jobs\" data-v-449a6627></i>Has jobs</span><span data-v-449a6627><i class=\"ojc-swatch cell-unavailable\" data-v-449a6627></i>Unavailable</span><span data-v-449a6627><i class=\"ojc-swatch cell-pending\" data-v-449a6627></i>⏳ Pending approval (still free)</span><span data-v-449a6627><i class=\"ojc-swatch cell-clash\" data-v-449a6627></i>Clash (jobs on an unavailable day)</span><span data-v-449a6627><i class=\"ojc-swatch cell-overlap\" data-v-449a6627></i>⚠ Overlapping jobs</span><span data-v-449a6627><i class=\"ojc-swatch cell-free cell-past\" data-v-449a6627></i>Past</span><span data-v-449a6627><i class=\"ojc-swatch cell-free cell-today\" data-v-449a6627></i>Today</span></div><div class=\"text-muted small mt-1\" data-v-449a6627>Click a job to edit it. Click a day from today onward (not an unavailable day) to add a job for this officer.</div>", 2)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mt-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
          }, "Close")
        ])
      ])
    ]),
    _createVNode(_component_JobModal, {
      ref: "jobModal",
      baseUrl: _ctx.baseUrl,
      officers: _ctx.lookup.officers || [],
      officerGroups: _ctx.lookup.officerGroups || [],
      sites: _ctx.lookup.sites || [],
      jobStatuses: _ctx.lookup.jobStatuses || [],
      onJobAdded: _ctx.fetchJobs,
      onJobUpdated: _ctx.fetchJobs
    }, null, 8, ["baseUrl", "officers", "officerGroups", "sites", "jobStatuses", "onJobAdded", "onJobUpdated"])
  ]))
}